import { getPathRegex, parseQueryString } from './paths';

export const getParamsFromProps = (props = {}) => {
  const { match = {} } = props;
  const { params = {} } = match;

  return params;
};

export const getQueryParamsFromProps = ({ location = {} } = {}) => {
  return parseQueryString(location.search || '');
};

export const getNamedParamFromProps = (name, props = {}) => {
  const params = getParamsFromProps(props);
  return Object.prototype.hasOwnProperty.call(params, name) && params[name] ? params[name] : null;
};

export const getSubParamsFromPatternAndProps = (pathName, pathPattern, props = {}) => {
  const path = getNamedParamFromProps(pathName, props);
  const [re, regexpKeys] = getPathRegex(pathPattern);

  const regexResults = re.exec(path);

  const results = {};
  regexpKeys.forEach((regexpKey, index) => {
    results[regexpKey.name] = regexResults[index + 1];
  });

  return results;
};
